import { takeLatest, put } from 'redux-saga/effects';

import {
    UPDATE_CALENDAR_RULES
} from './constants';

import {
    requestUpdateCalendarRules
} from './api';

import {
    updateCalendarRulesSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{rules, type}>>}
 */
function* updateCalendarRules( actionObj ) {
    const rules = yield requestUpdateCalendarRules( actionObj.id, actionObj.value );
    if ( rules ) {
        yield put( updateCalendarRulesSuccess( rules ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchRules() {
    yield takeLatest( UPDATE_CALENDAR_RULES, updateCalendarRules );
}

export default watchRules;